import pointsBackground from "@/assets/figma/chat-context-bar/points-background.png";
import quoteBackground from "@/assets/figma/chat-context-bar/quote-background.png";

export const MERRY_CHAT_CONTEXT_BAR_COMPONENT_ID = "631:115706";

export const MERRY_CHAT_CONTEXT_BAR_TYPE_ORDER = [
  "resource",
  "quote",
] as const;

export type MerryChatContextBarType =
  (typeof MERRY_CHAT_CONTEXT_BAR_TYPE_ORDER)[number];

export interface MerryChatContextBarVariant {
  backgroundSource: string;
  height: 85;
  nodeId: string;
  title: string;
  width: 1040 | 1200;
}

const variants = {
  resource: {
    backgroundSource: pointsBackground,
    height: 85,
    nodeId: "631:115739",
    title: "资源可用性",
    width: 1200,
  },
  quote: {
    backgroundSource: quoteBackground,
    height: 85,
    nodeId: "631:115707",
    title: "引用",
    width: 1040,
  },
} satisfies Record<MerryChatContextBarType, MerryChatContextBarVariant>;

export function getMerryChatContextBarVariant(
  type: MerryChatContextBarType,
): MerryChatContextBarVariant {
  return variants[type];
}

export function isMerryChatContextBarType(
  value: string,
): value is MerryChatContextBarType {
  return MERRY_CHAT_CONTEXT_BAR_TYPE_ORDER.some((type) => type === value);
}
